import { motion } from "framer-motion";

const AnimatedBackground = ({ variant = "global", showNeuralNodes = true, showParticles = true }) => {

    // Neural Network Nodes - AI Visualization
    const neuralNodes = Array.from({ length: 12 }, (_, i) => ({
        id: i,
        x: Math.random() * 100,
        y: Math.random() * 100,
        delay: Math.random() * 2,
        duration: 3 + Math.random() * 2
    }));

    return (
        <>
            {/* Fond de dégradé principal */}
            <div className="fixed inset-0 bg-gradient-to-br from-gray-900 via-black to-blue-900 z-0" />

            {/* Radial gradient pour effet de profondeur */}
            <div className="fixed inset-0 bg-[radial-gradient(circle_at_30%_50%,rgba(6, 182, 212, 0.1),transparent_50%)] z-0" />

            {/* Étoiles animées */}
            <div className="fixed inset-0 overflow-hidden z-0">
                {[...Array(20)].map((_, i) => (
                    <motion.div
                        key={i}
                        className="absolute w-1 h-1 bg-cyan-400/30 rounded-full"
                        initial={{
                            x: Math.random() * 100 + 'vw',
                            y: Math.random() * 100 + 'vh'
                        }}
                        animate={{
                            x: [null, Math.random() * 100 + 'vw'],
                            y: [null, Math.random() * 100 + 'vh']
                        }}
                        transition={{
                            duration: 20 + Math.random() * 10,
                            repeat: Infinity,
                            ease: "linear"
                        }}
                    />
                ))}

                {/* Neural Network Nodes */}
                {showNeuralNodes && neuralNodes.map((node) => (
                    <motion.div
                        key={`node-${node.id}`}
                        className="absolute w-3 h-3 rounded-full bg-cyan-400/60 shadow-lg shadow-cyan-400/50"
                        style={{
                            left: `${node.x}%`,
                            top: `${node.y}%`,
                        }}
                        animate={{
                            scale: [1, 1.5, 1],
                            opacity: [0.4, 0.8, 0.4],
                        }}
                        transition={{
                            duration: node.duration,
                            delay: node.delay,
                            repeat: Infinity,
                            ease: "easeInOut"
                        }}
                    />
                ))}

                {/* Floating Data Particles */}
                {showParticles && [...Array(30)].map((_, i) => (
                    <motion.div
                        key={`particle-${i}`}
                        className="absolute"
                        style={{
                            left: `${Math.random() * 100}%`,
                            top: `${Math.random() * 100}%`,
                        }}
                        animate={{
                            y: [0, -150, 0],
                            x: [0, Math.sin(i) * 100, 0],
                            opacity: [0, 0.8, 0],
                            scale: [0, 1, 0],
                        }}
                        transition={{
                            duration: 8 + Math.random() * 4,
                            delay: Math.random() * 5,
                            repeat: Infinity,
                            ease: "easeInOut"
                        }}
                    >
                        {i % 3 === 0 ? (
                            <div className="w-2 h-2 bg-blue-400/60 rounded-full shadow-lg shadow-blue-400/40" />
                        ) : i % 3 === 1 ? (
                            <div className="w-2 h-2 bg-cyan-400/60 rotate-45 shadow-lg shadow-cyan-400/40" />
                        ) : (
                            <div className="w-1.5 h-1.5 bg-purple-400/60 rounded-sm shadow-lg shadow-purple-400/40" />
                        )}
                    </motion.div>
                ))}

                {/* Cybersecurity Grid Overlay */}
                <div className="absolute inset-0 opacity-20" />
            </div>
        </>
    );
};

export default AnimatedBackground;
